import { cn, Input, Typography } from "@vintecc/components";
import { useMemo, useState, type FC } from "react";
import { useTranslation } from "react-i18next";

export const DebugTranslationExplorer: FC = () => {
  const [search, setSearch] = useState("");
  const { i18n } = useTranslation();
  const allTranslations = i18n.services.resourceStore.data;

  const filteredTranslations = useMemo(() => {
    const filteredTranslationsByLang: Record<string, Record<string, Record<string, string>>> = {};
    for (const [lang, namespaces] of Object.entries(allTranslations)) {
      const filteredNamespaces: Record<string, Record<string, string>> = {};
      for (const [ns, translations] of Object.entries(namespaces)) {
        const filteredKeys = Object.entries(translations).filter(([key, value]) => key.includes(search) || value.includes(search));
        if (filteredKeys.length === 0) {
          continue;
        }
        filteredNamespaces[ns] = Object.fromEntries(filteredKeys);
      }
      if (Object.keys(filteredNamespaces).length === 0) {
        continue;
      }
      filteredTranslationsByLang[lang] = filteredNamespaces;
    }
    return filteredTranslationsByLang;
  }, [allTranslations, search]);

  return (
    <div>
      <Input
        testId="debug-translation-search"
        placeholder="Search translation keys..."
        label="Search Translations"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        className="sticky top-0 bg-white py-4"
      />

      {Object.entries(filteredTranslations).map(([lang, namespaces]) => (
        <div key={lang} className="mt-4">
          <Typography variant="h3" as="strong">
            {lang}
          </Typography>
          {Object.entries(namespaces).map(([ns, translations]) => (
            <div key={ns} className="mt-2">
              <Typography variant="strong">{ns}</Typography>
              <dl className="list-disc">
                {Object.entries(translations).map(([key, value]) => (
                  <div key={key} className={cn("flex gap-2 justify-between", "bg-grey-100 p-2 rounded", "even:bg-white")}>
                    <dt>
                      <Typography variant="strong" className="text-start">
                        {key}
                      </Typography>
                    </dt>
                    <dd className="text-end">{value}</dd>
                  </div>
                ))}
              </dl>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};
